// tables/TransferReceiptTable.tsx
import React from 'react';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';

interface TransferReceiptTableProps {
  data: any[];
  selectedId: string | null;
  onSelect: (id: string, code: string) => void;
  isLoading: boolean;
  language: string;
}

export const TransferReceiptTable: React.FC<TransferReceiptTableProps> = ({
  data,
  selectedId,
  onSelect,
  isLoading,
  language
}) => {
  const { t } = useTranslation();
  const isArabic = language === 'ar';

  if (isLoading) {
    return (
      <div className='text-center py-5'>
        <div className='spinner-border text-primary' role='status'>
          <span className='visually-hidden'>{t('Loading')}</span>
        </div>
        <p className='text-muted mt-2'>{t('LoadingTransferOrders')}</p>
      </div>
    );
  }

  return (
    <Card className='mb-4'>
      <div className='card-header d-flex justify-content-between align-items-center'>
        <h6 className='mb-0'>
          <i className='fas fa-truck-loading me-2'></i>
          {t('TransferOrdersListTitle')}
        </h6>
      </div>

      <div className='card-body p-0'>
        <div className='table-responsive' style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <table className='table table-hover mb-0'>
            <thead className='fw-bold' style={{ position: 'sticky', top: 0, zIndex: 1, backdropFilter: 'blur(20px)' }}>
              <tr>
                <th className=' small'>#</th>
                <th className=' small'>{t('رقم الصرف المخزني للأمر')}</th>
                <th className=' small'>{t('Date')}</th>
                <th className=' small'>{t('رقم أمر التحويـل')}</th>
                <th className=' small'>من</th>
              </tr>
            </thead>
            <tbody>
              {data.map(item => {
                const isSelected = selectedId === item.id;

                return (
                  <tr
                    key={item.id}
                    className={isSelected ? 'table-primary' : ''}
                    style={{ cursor: 'pointer' }}
                    onClick={() => onSelect(item.id, item.code)}
                  >
                    <td className=' align-middle'>
                      <div className='form-check'>
                        <input
                          type='radio'
                          className='form-check-input'
                          name='transferReceiptSelection'
                          checked={isSelected}
                          onChange={() => onSelect(item.id, item.code)}
                        />
                      </div>
                    </td>

                    <td className=' align-middle fw-bold'>{item.code}</td>

                    <td className=' align-middle'>{item.transactionDate ? item.transactionDate.split('T')[0] : '-'}</td>

                    <td className=' align-middle'>{item.referenceCode || '-'}</td>
                    <td className='text-center align-middle'>
                      <div className='d-flex flex-column '>
                        <small className='d-flex align-items-center'>
                          <i className='fas fa-building me-1'></i> وحدة التشغيل:{' '}
                          {(isArabic ? item.branchToName2 : item.branchToName) || '—'}
                        </small>

                        <small className='d-flex align-items-center'>
                          <i className='fas fa-warehouse me-1'></i> المخزن:{' '}
                          {(isArabic ? item.inventory2 : item.inventory) || '—'}
                        </small>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <div className='card-footer d-flex justify-content-between align-items-center'>
        <div className='text-muted small'>
          {t('TransferOrdersFooterSummary', {
            count: data.length,
            total: data.length
          })}
        </div>
      </div>
    </Card>
  );
};
